module.exports = __webpack_public_path__ + "img/icon_text.7c8482d8.svg";